import { ChangeDetectionStrategy, Component, computed, model } from '@angular/core';
import { Theme } from '@navstation-portal/shared/data-model/theme';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

const themeConfig = {
  [Theme.Light]: { icon: 'pi pi-sun', switchToKey: 'SHARED.THEME_TOGGLE.SWITCH_TO_DARK', next: Theme.Dark },
  [Theme.Dark]: { icon: 'pi pi-moon', switchToKey: 'SHARED.THEME_TOGGLE.SWITCH_TO_LIGHT', next: Theme.Light },
} as const satisfies Record<Theme, { icon: string; switchToKey: string; next: Theme }>;

@Component({
  selector: 'nsp-theme-selector',
  templateUrl: './theme-selector.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, ButtonModule],
})
export class ThemeSelectorComponent {
  theme = model.required<Theme>();

  readonly activeConfig = computed(() => themeConfig[this.theme()]);

  toggleTheme = () => this.theme.set(this.activeConfig().next);
}
